import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { useExtensionPermissions } from '@/api/use-extension-permissions';
import { ringTimeoutAtom } from '@/store/atoms';

export const useSetRingTimeout = () => {
  const setRingTimeout = useSetAtom(ringTimeoutAtom);
  const { data: permissions } = useExtensionPermissions();

  useEffect(() => {
    if (permissions) {
      const timeout =
        typeof permissions.rejectCallAfter === 'number'
          ? permissions.rejectCallAfter
          : -1;

      if (timeout >= 1 && timeout < 60) {
        setRingTimeout(timeout);
      } else {
        setRingTimeout(-1);
      }
    }
  }, [permissions, setRingTimeout]);
};
